<template>
  <div class="pt-5">
    <SimpleSectionHeader
      :title="pageTitle"
      class="pb-0 tw-pt-30"
      isSectionTitle
    />

    <div class="container section-politiques">
      <CardWithLineGeneric v-for="item in texts" :key="item.id || item.var_name">
        <template v-slot:title>
          <vue-feather type="check" class="tw-text-orange-500 me-3" />
          {{ item.label }}
        </template>
        <template v-slot:body>
          <div
            class="cms-richtext"
            v-html="interpolateDynamicText(item.body || '')"
          ></div>
        </template>
      </CardWithLineGeneric>

      <CardWithLineGeneric v-if="!isLoading && !texts.length">
        <template v-slot:title>
          <vue-feather type="check" class="tw-text-orange-500 me-3" />
          Contenu indisponible
        </template>
        <template v-slot:body>
          Les textes de la politique de confidentialite n'ont pas encore ete
          publies.
        </template>
      </CardWithLineGeneric>
    </div>
  </div>
</template>

<script>
import { APP_NAME, APP_EMAIL } from "../../statics/app_static";
import { fetchCmsPublicPage, interpolateCmsText } from "../../statics/cms";
import CardWithLineGeneric from "../generics/Cards/CardWithLine/CardWithLineGeneric.vue";
import SimpleSectionHeader from "../generics/Headers/SimpleSectionHeader/SimpleSectionHeader.vue";

export default {
  name: "PolitiquesConfidentialite",
  components: {
    SimpleSectionHeader,
    CardWithLineGeneric,
  },
  data() {
    return {
      APP_NAME,
      APP_EMAIL,
      isLoading: false,
      texts: [],
      pageTitle: "POLITIQUE DE CONFIDENTIALITE",
    };
  },
  mounted() {
    this.loadCmsTexts();
  },
  methods: {
    async loadCmsTexts() {
      this.isLoading = true;
      try {
        const { pageLabel, texts } = await fetchCmsPublicPage(
          "politiques-confidentialite"
        );
        this.texts = texts;
        if (pageLabel) {
          this.pageTitle = String(pageLabel).toUpperCase();
        }
      } catch {
        this.texts = [];
      } finally {
        this.isLoading = false;
      }
    },
    interpolateDynamicText(text) {
      return interpolateCmsText(text, {
        APP_NAME: this.APP_NAME,
        APP_EMAIL: this.APP_EMAIL,
      });
    },
  },
};
</script>
